/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { createSelector } from "reselect";
import {
  getListViewObj,
  titles,
  getAllUserListViewObj,
  getUserDataDetails,
} from "./helper";
import { getauth } from "../auth/selectors";
import { SUPER_ADMIN_ROLE } from "../../constants/Constants";

export const getUser = (state) => state.user;
export const getUserLength = createSelector(
  [getUser],
  (user) => user.list.length,
);

export const getUsers = createSelector([getUser, getauth], (user, auth) =>
  user && user.list && user.list.length > 0
    ? user.list.map((userDet) => getListViewObj(userDet, auth))
    : [],
);
export const getUsersList = createSelector([getUser, getauth], (user, auth) =>
  user && user.list && user.list.length > 0
    ? user.list.map((userDet) => getAllUserListViewObj(userDet, auth))
    : [],
);
export const getCurrentUser = createSelector([getUser], (user) =>
  user && user.currentUser ? user.currentUser : null,
);
export const getCurrentUserDetails = createSelector([getUser], (user) =>
  user && user.currentUserDetails
    ? getUserDataDetails(user && user.currentUserDetails)
    : null,
);
export const getUsersDetailsLoadingStatus = createSelector(
  [getUser],
  (user) => ({
    currentUserDetailsLoading:
      user && user.currentUserDetailsLoading
        ? user.currentUserDetailsLoading
        : false,
    currentUserDetailsLoaded:
      user && user.currentUserDetailsLoaded
        ? user.currentUserDetailsLoaded
        : false,
  }),
);
export const getUserSuccessResponse = createSelector([getUser], (user) =>
  user && user.successResponse ? user.successResponse : undefined,
);
export const getUserErrorResponse = createSelector([getUser], (user) =>
  user && user.errorResponse ? user.errorResponse : undefined,
);
export const getToggleStatus = createSelector([getUser], (user) => ({
  togglingStatus: user && user.togglingStatus ? user.togglingStatus : undefined,
  toggleStatusResponse:
    user && user.toggleStatusResponse ? user.toggleStatusResponse : undefined,
  toggleStatusError:
    user && user.toggleStatusError ? user.toggleStatusError : undefined,
}));
export const getUsersLoadingStatus = createSelector([getUser], (user) => ({
  loading: user && user.isLoading ? user.isLoading : false,
  loaded: user && user.isLoaded ? user.isLoaded : false,
}));
export const getUsersApiLoadingStatus = createSelector([getUser], (user) => ({
  loading: user && user.loadingApi ? user.loadingApi : false,
  loaded: user && user.loadedApi ? user.loadedApi : false,
}));
export const getUserTotalCount = createSelector([getUser], (user) =>
  user && user.total ? user.total : 0,
);
export const getTitles = createSelector([getauth], (auth) => {
  const titlesNow = JSON.parse(JSON.stringify(titles));
  if (auth && auth.user && auth.user.roleName === SUPER_ADMIN_ROLE) {
    titlesNow.push({
      key: "company",
      label: "Company",
    });
  }
  titlesNow.push({
    key: "action",
  });
  return titlesNow;
});
export const getUserDeleteSuccessResponse = createSelector([getUser], (user) =>
  user && user.deleteSuccessResponse ? user.deleteSuccessResponse : undefined,
);
export const getUserResendSuccessResponse = createSelector([getUser], (user) =>
  user && user.resendSuccessResponse ? user.resendSuccessResponse : undefined,
);
export const getUserUpdateSuccessResponse = createSelector([getUser], (user) =>
  user && user.userUpdateSuccessResponse
    ? user.userUpdateSuccessResponse
    : undefined,
);
export const getUserRoles = createSelector([getUser], (user) =>
  user?.roleList?.name ? user.roleList.name : undefined,
);
